// <auto-generated />
// This file was generated by Medfar's Pdf Mapping Inkscape extension.
// Don't change it directly as your change would get overwritten.
// For more info take a look at the extension README (Myle.PdfFormGenerator/InkscapeExtension/readme.md)
// and the pdf generator README(Myle.PdfFormGenerator/readme.md)

class QuebecObstetricalFileFieldLimits {
    public static Page1 = {
        ClinicAddress: { MaxChars: 45, MaxRows: 1 },
        ClinicFax: { MaxChars: 14, MaxRows: 1 },
        ClinicName: { MaxChars: 135, MaxRows: 3 },
        ClinicPhone: { MaxChars: 14, MaxRows: 1 },
        CurrentPregnancyAbdominalPain: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyBleeding: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyConstipation: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyEdema: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyHeadaches: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyNauseaAndVomiting: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyRemarks: { MaxChars: 303, MaxRows: 3 },
        CurrentPregnancyRgo: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyUrinarySymptoms: { MaxChars: 3, MaxRows: 1 },
        CurrentPregnancyVaginalDischarge: { MaxChars: 3, MaxRows: 1 },
        FamilyAntecedents: { MaxChars: 333, MaxRows: 3 },
        LifestyleAndEnvironmentAlcohol: { MaxChars: 4, MaxRows: 1 },
        LifestyleAndEnvironmentCigarettes: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentCoffee: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentContactCat: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentDrugs: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentEthnocultural: { MaxChars: 4, MaxRows: 1 },
        LifestyleAndEnvironmentFeeding: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentFolicAcidSupplement: { MaxChars: 4, MaxRows: 1 },
        LifestyleAndEnvironmentMedication: { MaxChars: 4, MaxRows: 1 },
        LifestyleAndEnvironmentOccupation: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentRadiationXrays: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentRemarks: { MaxChars: 303, MaxRows: 3 },
        LifestyleAndEnvironmentRiskOfInfection: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentSociocultural: { MaxChars: 3, MaxRows: 1 },
        LifestyleAndEnvironmentTrauma: { MaxChars: 4, MaxRows: 1 },
        LifestyleAndEnvironmentVaccination: { MaxChars: 3, MaxRows: 1 },
        MenstrualHistoryLengthInDays: { MaxChars: 8, MaxRows: 1 },
        PageOneSignature: { MaxChars: 52, MaxRows: 1 },
        PageOneSummary: { MaxChars: 270, MaxRows: 6 },
        PatientAge: { MaxChars: 7, MaxRows: 1 },
        PatientFirstName: { MaxChars: 28, MaxRows: 1 },
        PatientFullFormattedAddress: { MaxChars: 174, MaxRows: 3 },
        PatientHealthInsuranceNumber: { MaxChars: 57, MaxRows: 1 },
        PatientLastNameAtBirth: { MaxChars: 28, MaxRows: 1 },
        PersonalAntecedentsAllergiesAsthma: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsBloodDyscrasia: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsBloodTransfusions: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsCardiacDesease: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsChickenPox: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsDiabetes: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsDvtOrPe: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsEpilepsy: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsGenitalHerpes: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsHepatitisB: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsHypertension: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsNeuropsychiatricDisease: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsPreviousSurgery: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsRenalDesease: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsRhAboIncompatibility: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsSpecify: { MaxChars: 309, MaxRows: 3 },
        PersonalAntecedentsStbbis: { MaxChars: 4, MaxRows: 1 },
        PersonalAntecedentsThyroidDesease: { MaxChars: 4, MaxRows: 1 },
        PreviousPregnanciesAbortion: { MaxChars: 8, MaxRows: 1 },
        PreviousPregnanciesLivingChildren: { MaxChars: 8, MaxRows: 1 },
        PreviousPregnanciesPremature: { MaxChars: 8, MaxRows: 1 },
        PreviousPregnanciesRemarks: { MaxChars: 303, MaxRows: 3 },
        PreviousPregnanciesTableDate: { MaxChars: 12, MaxRows: 1 },
        PreviousPregnanciesTableDurationOfLabourInHours: { MaxChars: 6, MaxRows: 1 },
        PreviousPregnanciesTableDurationOfPregnancyInWeeks: { MaxChars: 7, MaxRows: 1 },
        PreviousPregnanciesTableMaleOrFemale: { MaxChars: 6, MaxRows: 1 },
        PreviousPregnanciesTableMassInKg: { MaxChars: 7, MaxRows: 1 },
        PreviousPregnanciesTableMethodOfDelivery: { MaxChars: 13, MaxRows: 1 },
        PreviousPregnanciesTableNo: { MaxChars: 3, MaxRows: 1 },
        PreviousPregnanciesTableParticularitiesChild: { MaxChars: 16, MaxRows: 1 },
        PreviousPregnanciesTableParticularitiesMother: { MaxChars: 16, MaxRows: 1 },
        PreviousPregnanciesTablePlace: { MaxChars: 8, MaxRows: 1 },
        PreviousPregnanciesTableTypeOfAnesthesia: { MaxChars: 10, MaxRows: 1 },
        PreviousPregnanciesTerm: { MaxChars: 8, MaxRows: 1 },
        SpouseAge: { MaxChars: 7, MaxRows: 1 },
        SpouseDescription: { MaxChars: 111, MaxRows: 1 },
        SpouseFullName: { MaxChars: 42, MaxRows: 1 },
        SpouseMedicalProblemsAndFamilyAntecedents: { MaxChars: 51, MaxRows: 1 }
    };

    public static Page2 = {
        ClinicAddress: { MaxChars: 45, MaxRows: 1 },
        ClinicFax: { MaxChars: 14, MaxRows: 1 },
        ClinicName: { MaxChars: 135, MaxRows: 3 },
        ClinicPhone: { MaxChars: 14, MaxRows: 1 },
        PageTwoSignature: { MaxChars: 52, MaxRows: 1 },
        PageTwoSummary: { MaxChars: 270, MaxRows: 6 },
        PatientAge: { MaxChars: 7, MaxRows: 1 },
        PatientFirstName: { MaxChars: 28, MaxRows: 1 },
        PatientFullFormattedAddress: { MaxChars: 174, MaxRows: 3 },
        PatientHealthInsuranceNumber: { MaxChars: 57, MaxRows: 1 },
        PatientLastNameAtBirth: { MaxChars: 28, MaxRows: 1 },
        PhysicalExamAbdomen: { MaxChars: 26, MaxRows: 1 },
        PhysicalExamAdnexa: { MaxChars: 26, MaxRows: 1 },
        PhysicalExamBloodPressure: { MaxChars: 17, MaxRows: 1 },
        PhysicalExamBMI: { MaxChars: 17, MaxRows: 1 },
        PhysicalExamBreasts: { MaxChars: 28, MaxRows: 1 },
        PhysicalExamCervix: { MaxChars: 26, MaxRows: 1 },
        PhysicalExamCorrespondenceBetweenUterineVolumeAndAgeOfPregnancy: { MaxChars: 23, MaxRows: 1 },
        PhysicalExamCurrentWeight: { MaxChars: 15, MaxRows: 1 },
        PhysicalExamHeart: { MaxChars: 37, MaxRows: 1 },
        PhysicalExamHeight: { MaxChars: 14, MaxRows: 1 },
        PhysicalExamLowerLimbs: { MaxChars: 26, MaxRows: 1 },
        PhysicalExamLungs: { MaxChars: 35, MaxRows: 1 },
        PhysicalExamNeck: { MaxChars: 35, MaxRows: 1 },
        PhysicalExamParticularities: { MaxChars: 550, MaxRows: 5 },
        PhysicalExamPerineum: { MaxChars: 26, MaxRows: 1 },
        PhysicalExamThyroid: { MaxChars: 17, MaxRows: 1 },
        PhysicalExamUterus: { MaxChars: 26, MaxRows: 1 },
        PhysicalExamVagina: { MaxChars: 28, MaxRows: 1 },
        PhysicalExamWeightBeforePregnancy: { MaxChars: 15, MaxRows: 1 },
        RiskFactorCongenitalAnomaliesPlan: { MaxChars: 180, MaxRows: 3 },
        RiskFactorDiabetesPlan: { MaxChars: 180, MaxRows: 3 },
        RiskFactorHypertensionPlan: { MaxChars: 180, MaxRows: 3 },
        RiskFactorMaternalPlan: { MaxChars: 180, MaxRows: 3 },
        RiskFactorPregnancyAfterInVitroFertilizationPlan: { MaxChars: 180, MaxRows: 3 },
        RiskFactorPresenceOfSTBBIPlan: { MaxChars: 300, MaxRows: 5 },
        RiskFactorPretermLabourOther: { MaxChars: 41, MaxRows: 1 },
        RiskFactorPretermLabourPlan: { MaxChars: 300, MaxRows: 5 },
        RiskFactorRestrictedIntrauterineGrowthOther: { MaxChars: 41, MaxRows: 1 },
        RiskFactorRestrictedIntrauterineGrowthPlan: { MaxChars: 300, MaxRows: 5 },
        RiskFactorVBACPlan: { MaxChars: 300, MaxRows: 5 }
    };

    public static Page3 = {
        ClinicAddress: { MaxChars: 45, MaxRows: 1 },
        ClinicFax: { MaxChars: 14, MaxRows: 1 },
        ClinicName: { MaxChars: 135, MaxRows: 3 },
        ClinicPhone: { MaxChars: 14, MaxRows: 1 },
        ComplementaryExamsAmniocentesisResults: { MaxChars: 170, MaxRows: 5 },
        ComplementaryExamsGlycemiaFasting: { MaxChars: 12, MaxRows: 1 },
        ComplementaryExamsGlycemiaOpen0: { MaxChars: 12, MaxRows: 1 },
        ComplementaryExamsGlycemiaOpen1: { MaxChars: 12, MaxRows: 1 },
        ComplementaryExamsGlycemiaPost50g: { MaxChars: 12, MaxRows: 1 },
        ComplementaryExamsGlycemiaPost75g: { MaxChars: 12, MaxRows: 1 },
        ComplementaryExamsHemoglobin0: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsHemoglobin1: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsImmunitySerologyChickenPox: { MaxChars: 15, MaxRows: 1 },
        ComplementaryExamsImmunitySerologyParvoB19: { MaxChars: 15, MaxRows: 1 },
        ComplementaryExamsImmunitySerologyToxo: { MaxChars: 14, MaxRows: 1 },
        ComplementaryExamsImmunitySerologyValue0: { MaxChars: 14, MaxRows: 1 },
        ComplementaryExamsImmunitySerologyValue1: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsMothersTypeRhFactorAntibodies0: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsMothersTypeRhFactorAntibodies1: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsMothersTypeRhFactorAntibodies2: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsMothersTypeRhType: { MaxChars: 16, MaxRows: 1 },
        ComplementaryExamsRiskAccordingToOther: { MaxChars: 58, MaxRows: 1 },
        ComplementaryExamsRiskAccordingToQpspt21: { MaxChars: 15, MaxRows: 1 },
        ComplementaryExamsT21ScreeningNuchalTranslucency: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsThyroidStimulationHormoneValue0: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsThyroidStimulationHormoneValue1: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsThyroidStimulationHormoneValue2: { MaxChars: 13, MaxRows: 1 },
        ComplementaryExamsUltrasoundClinicalAge: { MaxChars: 14, MaxRows: 1 },
        ComplementaryExamsUltrasoundPlacenta0: { MaxChars: 14, MaxRows: 1 },
        ComplementaryExamsUltrasoundPlacenta1: { MaxChars: 14, MaxRows: 1 },
        ComplementaryExamsUltrasoundUltrasoundAge: { MaxChars: 14, MaxRows: 1 },
        ComplementaryExamsUrine: { MaxChars: 31, MaxRows: 1 },
        PageThreeSummary: { MaxChars: 270, MaxRows: 6 },
        PatientAge: { MaxChars: 7, MaxRows: 1 },
        PatientFirstName: { MaxChars: 28, MaxRows: 1 },
        PatientFullFormattedAddress: { MaxChars: 174, MaxRows: 3 },
        PatientHealthInsuranceNumber: { MaxChars: 57, MaxRows: 1 },
        PatientLastNameAtBirth: { MaxChars: 28, MaxRows: 1 },
        PossibleDiscussionsComments: { MaxChars: 2616, MaxRows: 24 }
    };

    public static Page4 = {
        Abortion: { MaxChars: 6, MaxRows: 1 },
        ClinicAddress: { MaxChars: 45, MaxRows: 1 },
        ClinicFax: { MaxChars: 14, MaxRows: 1 },
        ClinicName: { MaxChars: 135, MaxRows: 3 },
        ClinicPhone: { MaxChars: 14, MaxRows: 1 },
        EstimatedDateOfConfinementRemarks: { MaxChars: 198, MaxRows: 9 },
        Gravida: { MaxChars: 6, MaxRows: 1 },
        Live: { MaxChars: 6, MaxRows: 1 },
        PageThreeSummary: { MaxChars: 270, MaxRows: 6 },
        Particularities: { MaxChars: 363, MaxRows: 3 },
        PatientAge: { MaxChars: 7, MaxRows: 1 },
        PatientFirstName: { MaxChars: 28, MaxRows: 1 },
        PatientFullFormattedAddress: { MaxChars: 174, MaxRows: 3 },
        PatientHealthInsuranceNumber: { MaxChars: 57, MaxRows: 1 },
        PatientLastNameAtBirth: { MaxChars: 28, MaxRows: 1 },
        Premature: { MaxChars: 6, MaxRows: 1 },
        PrenatalVisitsAlbuminuria: { MaxChars: 10, MaxRows: 2 },
        PrenatalVisitsBloodPressure: { MaxChars: 8, MaxRows: 2 },
        PrenatalVisitsContractions: { MaxChars: 10, MaxRows: 2 },
        PrenatalVisitsEdema: { MaxChars: 6, MaxRows: 2 },
        PrenatalVisitsExtraInformation: { MaxChars: 140, MaxRows: 2 },
        PrenatalVisitsFetalHeart: { MaxChars: 10, MaxRows: 2 },
        PrenatalVisitsFetalMovement: { MaxChars: 10, MaxRows: 2 },
        PrenatalVisitsGlycosuria: { MaxChars: 10, MaxRows: 2 },
        PrenatalVisitsHeightOfUterineFundus: { MaxChars: 4, MaxRows: 2 },
        PrenatalVisitsInitials: { MaxChars: 6, MaxRows: 2 },
        PrenatalVisitsPresentation: { MaxChars: 6, MaxRows: 2 },
        PrenatalVisitsTreatmentOrRemarks: { MaxChars: 84, MaxRows: 2 },
        PrenatalVisitsWeeksOfGestation: { MaxChars: 6, MaxRows: 2 },
        PrenatalVisitsWeight: { MaxChars: 12, MaxRows: 2 },
        PrenatalVisitsWeightBeforePregnancy: { MaxChars: 8, MaxRows: 2 },
        Term: { MaxChars: 6, MaxRows: 1 }
    };
}

export { QuebecObstetricalFileFieldLimits };
